var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74068 26.0202L10.858 17.8202L15.2447 22.0202L20.606 17.3335L23.5927 20.2455M29.3327 7.3335C29.3327 6.80306 29.122 6.29436 28.7469 5.91928C28.3718 5.54421 27.8631 5.3335 27.3327 5.3335H4.66602C4.13558 5.3335 3.62687 5.54421 3.2518 5.91928C2.87673 6.29436 2.66602 6.80306 2.66602 7.3335V13.3335H29.3327V7.3335Z",
    stroke: "#FFB85C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 12.0002V24.6668C29.3327 25.1973 29.122 25.706 28.7469 26.081C28.3718 26.4561 27.8631 26.6668 27.3327 26.6668H7.99935M12.7407 9.3335H24.7407M7.40602 9.3335H8.73935M2.66602 12.0002V18.0002",
    stroke: "#FFB85C",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.c0ecda737f4a586bff867678beb43d7a.svg";
export { ForwardRef as ReactComponent };